import Vue from "vue";
import Vuex from "vuex";

import chat from "./modules/chat";
import customerChat from "./modules/customerChat";
import dashboard from "./modules/dashboard";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    chat: chat,
    customerChat: customerChat,
    dashboard: dashboard,
  },
});
